import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.58 11.693v2.66C15.482 14.832 5.88 24.85 6 37.039l.016 1.571c.008.834 1.05 1.207 1.586.567l1.023-1.221A25.89 25.89 0 0 1 27.578 28.7l-.006 2.74a2.693 2.693 0 0 0 4.665 1.84l8.921-9.59a3.142 3.142 0 0 0-.003-4.284l-8.913-9.55a2.693 2.693 0 0 0-4.662 1.837Zm1.795 16.095a.898.898 0 0 0-.898-.9 27.686 27.686 0 0 0-20.671 9.27c.341-11.027 9.332-19.915 20.465-20.025l.206-.001a.898.898 0 0 0 .898-.898v-3.54a.898.898 0 0 1 1.554-.613l8.913 9.55c.483.517.483 1.319.002 1.836l-8.922 9.59a.898.898 0 0 1-1.555-.614l.008-3.655Z",
    fill: "currentColor"
  }));
};

var SvgForward = styled(SvgComponent).withConfig({
  displayName: "Forward__SvgForward",
  componentId: "sc-19btsrg-0"
})(["", " ", ""], size, color);
export default SvgForward;